import { defineStore } from "pinia"
import { ref } from "vue"

interface ModalOptions {
  title: string
  message: string
  confirmText?: string
  cancelText?: string
  onConfirm?: () => void | Promise<void>
  onCancel?: () => void
}

export const useModalStore = defineStore("modalStore", () => {
  const isOpen = ref(false)
  const title = ref("")
  const message = ref("")
  const confirmText = ref("OK")
  const cancelText = ref("Cancel")

  let confirmCallback: (() => void | Promise<void>) | null = null
  let cancelCallback: (() => void | Promise<void>) | null = null

  function open(options: ModalOptions) {
    title.value = options.title
    message.value = options.message
    confirmText.value = options.confirmText ?? "OK"
    cancelText.value = options.cancelText ?? "Cancel"

    confirmCallback = options.onConfirm ?? null
    cancelCallback = options.onCancel ?? null

    isOpen.value = true
  }

  async function confirm() {
    if (confirmCallback) await confirmCallback()
    close()
  }

  function cancel() {
    if (cancelCallback) cancelCallback()
    close()
  }

  function close() {
    isOpen.value = false
  }

  return {
    isOpen,
    title,
    message,
    confirmText,
    cancelText,
    open,
    confirm,
    cancel,
    close,
  }
})
